export { default as company } from './company';
export { default as person } from './person';
export { default as carta } from './carta';
